export default class DttsController {
  constructor(ContentService, $uibModal, isMobile, Notification, moment, FileSaver, Blob, $translate,
    AccountService) {
    this.service = ContentService;
    this.modal = $uibModal;
    this.isMobile = isMobile;
    this.notify = Notification;
    this.moment = moment;
    this.FileSaver = FileSaver;
    this.Blob = Blob;
    this.trans = $translate.instant;
    this.accountService = AccountService
  }

  $onInit(){
    this.subscriptions = [];

    const _ = this.trans;
    this.inMobileView = this.isMobile.phone;

    this.subscriptions.push(
      this.dttsObservable.subscribe(
        (dttFiles) => {
          this.dttsProcessed = dttFiles.processed.map(i => {
            i.timestamp = this.moment.utc(i.timestamp).tz(
              this.accountService.timezone
            );
            return i;
          });
          this.dttsUnprocessed = dttFiles.unprocessed.map(i => {
            i.timestamp = this.moment.utc(i.timestamp).tz(
              this.accountService.timezone
            );
            return i;
          });
          this.dtts = this.dttsUnprocessed;
        },
        (error) => console.log(error)
      )
    );
    this.activeTab = 'A';
  }
  $onDestroy() {
    this.subscriptions.forEach(sub => sub.unsubscribe());
  }

  downloadDtt(dtt) {
    const _ = this.trans;
    this.subscriptions.push(
      this.service.downloadDTT(dtt.filename).subscribe(
        (data) => {
          var file = new this.Blob([data.data], { type: 'text/plain;charset=utf-8' });
          this.FileSaver.saveAs(file, dtt.filename);
        },
        () => {
          this.notify.error(_("Ha ocurrido un error tratando de descargar el backup, intente nuevamente"));
        }
      )
    );
  }

  processDtts(external=false) {
    const _ = this.trans;
    var response = this.service.triggerDttProcess();
    if (external) {
      return response;
    } else {
      this.subscriptions.push(
        response.subscribe(() => {
          that.notify.success(_("Los archivos pendientes están siendo procesados"));
        })
      );
    }
  }

  changePage(str, page){
    this.subscriptions.push(
      this.service.getDttsList(page).subscribe(
        (dttFiles) => {
          this.dttsProcessed = dttFiles.processed.map(i => {
            i.timestamp = this.moment.utc(i.timestamp).tz(
              this.accountService.timezone
            );
            return i;
          });
          this.dttsUnprocessed = dttFiles.unprocessed.map(i => {
            i.timestamp = this.moment.utc(i.timestamp).tz(
              this.accountService.timezone
            );
            return i;
          });
          this.dtts = this.dttsUnprocessed;
        },
        (error) => console.log(error)
      )
    );
  }

  openModalDtt(){
    var that = this;
    var allowedExtensions = ['dtt'];
    const _ = that.trans;
    this.modal.open({
      animation: true,
      size: 'lg',
      templateUrl: 'upload-dtt-template.html',
      appendClassName: 'ngdialog-theme-plain',
      controller: ($scope, $state, $uibModalInstance, FileUploader, host, AuthService, cfpLoadingBar) => {
        "ngInject";
        
        $scope.inMobileView = that.inMobileView;
        $scope.displayUploadedList = false;
        $scope.uploadedFiles = [];
        $scope.uploadingFiles = false;

        var fileUploader = $scope.fileUploader = new FileUploader({
          url: host + '/api/accounts/dtt-files',
          headers: {
            Authorization: 'Bearer ' + AuthService.getToken(),
            'X-Account-Token': AuthService.getAccountToken()
          },
          filters: [{
            name: 'allowedFile',
            fn: (item) => {
              // TODO: Display incorrect filetype message.
              return allowedExtensions.indexOf(item.name.toLowerCase().split('.').slice(-1)[0]) > -1;
            }
          }]
        });
        fileUploader.onSuccessItem = (item, response, status, headers) => {
          var uploadedItem = {
            id: response.id,
            filename: response.filename,
            filesize: response.filesize,
            timestamp: that.moment.utc(response.timestamp).tz(
              this.accountService.timezone
            )
          };
          $scope.uploadedFiles.push(uploadedItem);

          var foundAt = that.dttsUnprocessed.findIndex(i => i.filename === uploadedItem.filename);
          if (foundAt > -1) {
            that.dttsUnprocessed.splice(foundAt, 1, uploadedItem);
          } else {
            that.dttsUnprocessed.unshift(uploadedItem);
          }
        };
        fileUploader.onErrorItem = (item, response, status, headers) => {
          that.notify.error(_("Ha ocurrido un error tratando de subir los archivos, intente nuevamente"));
          console.log("An error happened while uploading file");
        };

        fileUploader.onProgressAll = (progress) => {
          cfpLoadingBar.set(progress / 100);
        };

        fileUploader.onCompleteAll = () => {
          $scope.displayUploadedList = true;
          $scope.uploadingFiles = false;
          cfpLoadingBar.complete();
        };

        $scope.closeThisDialog = () => $uibModalInstance.close();
        $scope.uploadDtt = () => {
          if (fileUploader.queue.length > 0) {
            fileUploader.uploadAll();
            cfpLoadingBar.start();
            $scope.uploadingFiles = true;
          }
        };
        $scope.processDtt = () => {
          that.subscriptions.push(
            that.processDtts(true).subscribe(() => {
              that.notify.success(_("Los archivos están siendo procesados"));
              $scope.closeThisDialog();
              $scope.uploadedFiles = [];
              $scope.displayUploadedList = false;
            })
          );
        };
        $scope.clearQueue = () => {
          fileUploader.clearQueue();
        };
      }
    });
  }

  formatSize(value) {
    var asNum = Number.parseFloat(value);
    return !Number.isNaN(asNum) ? asNum : '-';
  }
}

 DttsController.$inject = ['ContentService', '$uibModal', 'isMobile', 'Notification', 'moment', 'FileSaver', 'Blob', '$translate', 'AccountInformationService'];


// WEBPACK FOOTER //
// ./src/app/pages/dtts/dtts.controller.js